import { isStorageAvailable } from 'chameleon/ui-stack/ui/base/hooks/use-local-storage';
import * as types from '../constants/types';

const visitedUnits = (state = {}, action) => {
  switch (action.type) {
    case types.SET_VISITED_UNITS:
      const { subjectId, userId, unitNumber } = action.payload;

      let units = {
        ...state,
        [`${subjectId}-${userId}`]: {
          unitNumber,
        },
      };

      //@todo - revisit logic
      //isStorageAvailable method doesn't correctly check the space it would need to address
      if (!isStorageAvailable('localStorage')) {
        const firstKey = Object.keys(units)[0];
        delete units[firstKey];
      }

      return units;
    default:
      return state;
  }
};

export default visitedUnits;
